import { Flex, Text } from "styles/utility-components";

import Modal from "components/ui/modal/Modal";
import toast from "components/ui/toast/Toast";
import { useDeleteSavedViews } from "lib/hooks/api/notices/views/useDeleteSavedViews";
import Button from "../ui/button/Button";
import { ModalView } from "./utils";

type DeleteViewModalProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  selectedView: ModalView;
  onSuccess?: () => void;
};

export function DeleteViewModal({
  isOpen,
  selectedView,
  onOpenChange,
  onSuccess,
}: DeleteViewModalProps) {
  const { mutate: deleteSavedViews, isLoading } = useDeleteSavedViews({
    onSuccess: async () => {
      onOpenChange(false);
      onSuccess?.();
      toast.success(`Deleted search successfully!`);
    },
    onError: async () => {
      toast.error("Failed to delete search");
    },
  });

  return (
    <Modal open={isOpen} onOpenChange={onOpenChange} padding={24}>
      <Flex column gap={8}>
        <Text h3>Delete search</Text>
        <Text color="sysTextSecondary">
          Are you sure you want to delete <b>{selectedView.name}</b>?
        </Text>
        <Flex gap={8} justifyContent="flex-end">
          <Button buttonType="secondary" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            type="submit"
            loading={isLoading}
            onClick={() => deleteSavedViews({ request: { ids: [selectedView.id] } })}
          >
            Delete
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
